import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I learned two things today 21.8.",
  "description": "",
  "published": "2011-08-21T00:00:00.000Z",
  "redirect_from": ["/blog/i-learned-two-things-today-21-8/swizec/2275"],
  "categories": "Learning, Personal",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/08/Screen-Shot-2011-08-21-at-11.12.16-PM-300x255.png",
        "alt": null,
        "title": "Many postcards!"
      }}></img></p>
    <p>{`Today I learned that people really really love postcards. Bought one too many yesterday (it later turned out I didn't buy too many, I just forgot my grandmother might like getting one) and offered on Facebook on Twitter to send the first person who gives me their address a postcard.`}</p>
    <p>{`Five people asked for one. So now that I was going to buy postcards anyway I asked for random people who might like a postcard and ended up having to buy fourteen of them. Well ok, three of those are for some cool professors `}<a parentName="p" {...{
        "href": "http://twitter.com/zidarsk8"
      }}>{`@zidarsk8`}</a>{` reminded me of.`}</p>
    <p>{`Point is, people love postcards still.`}</p>
    <p>{`Another thing I learned is that in the US they have automated stamp dispensing machine. You just swipe a credit card, press a few buttons and ugly stamps come out. Quite an amazing system if you need stamps on a Sunday afternoon.`}</p>
    <p>{`PS: bonus thing I learned; wearing a bunny hat in Cheesecake Factory does not phase the waiters at all.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      